import React, { useState } from "react";
import { Container, Box, Typography, TextField, Button, Alert } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
const ConferenceForgetPassword = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [disabled, setDisabled] = useState(false);
    const eventid = localStorage.getItem('eventid');
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email) {
            setError("Please enter your email address");
            setSuccess("");
            return;
        }

        // Example email format validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setError("Please enter a valid email address");
            setSuccess("");
            return;
        }

        setError("");
        //setSuccess("Password reset link has been sent to your email.");
        const data = {
            eventid,
            emailAddress: email,
        }
        // Here you would call your API
        setDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/conference/forgot/password`, data).then(res => {
                if (res.data.status === true) {
                    setSuccess("Password reset link has been sent to your email.");
                    //swal('Success', res.data.message, 'success');
                    setDisabled(false);
                    setEmail("");
                    //history.push('/login');
                }
                if (res.data.status === 404) {
                    setDisabled(false);
                    swal('Warning', res.data.message, 'warning');
                }

                // else {
                //   //swal("Email Field is Required", "", "error");
                //   setError(res.data.validate_error);

                // }
            });


        });

        console.log("Sending reset link to:", email);
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    mt: 8,
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: "white",
                }}
            >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Forgot Password
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={3}>
                    Enter your registered email to receive a password reset link.
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email Address"
                        type="email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ mb: 3 }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ py: 1.2 }}
                        disabled={disabled}
                    >
                        Send Reset Link
                    </Button>
                </form>
            </Box>
        </Container>
    );
};

export default ConferenceForgetPassword;
